import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const getFeedbacks = async () => {
    const response = await apiService.get(apiRoutes.adminFeedbacks);
    return response.data;
};

export const destroyFeedback = async (feedbackId) => {
    const response = await apiService.post(apiRoutes.adminFeedbackDestroy, { feedbackId });
    return response.data;
};

export const getFeedbackDetail = async (feedbackId) => {
    const response = await apiService.post(apiRoutes.adminFeedbackDetail, { feedbackId });
    return response.data;
};

export const getSupports = async () => {
    const response = await apiService.get(apiRoutes.adminSupport);
    return response.data;
};


export const destroySupport = async (supportId) => {
    const response = await apiService.post(apiRoutes.adminSupportDestroy, { supportId });
    return response.data;
};


export const getSupportDetail = async (supportId) => {
    const response = await apiService.post(apiRoutes.adminSupportDetail, { supportId });
    return response.data;
};

export const resolveSupport = async (supportId) => {
    const response = await apiService.post(apiRoutes.adminSupportResolve, { supportId });
    return response.data;
};